/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 *
 * @author	Yann Massard, yamass@gmail.com
 * @author	Matthias Bernstein, matthias.bernstein@data-centrics.com
 */
export const typescriptDeclarationFixConstant = 1;
export interface UiEvent {
	_type: "UiDummyComponent.clicked"
			| "UiCalendar.eventClicked"
			| "UiCalendar.eventMoved"
			| "UiCalendar.dayClicked"
			| "UiCalendar.viewChanged"
			| "UiCalendar.dataNeeded"
			| "UiContextMenu.contextMenuSelection"
			| "UiGridForm.submitted"
			| "UiGridForm.sectionCollapsedStateChanged"
			| "UiImageDisplay.imagesRequest"
			| "UiImageDisplay.imageDisplayed"
			| "UiImageCropper.cropFrameChanged"
			| "UiInfiniteItemView.dataRequest"
			| "UiInfiniteItemView.itemClicked"
			| "UiItemView.itemClicked"
			| "UiSplitPane.resized"
			| "UiLiveStreamComponent.resultOfRequestInputDeviceAccess"
			| "UiLiveStreamComponent.resultOfRequestInputDeviceInfo"
			| "UiLiveStreamComponent.resultOfGetFlashPlayerVersion"
			| "UiRtmpLiveStreamPlayer.resultOfGetFlashPlayerVersion"
			| "UiMap.zoomLevelChange"
			| "UiMediaTrackGraph.handleTimeSelection"
			| "UiVideoPlayer.errorLoading"
			| "UiVideoPlayer.playerProgress"
			| "UiNavigationBar.buttonClicked"
			| "UiNetworkGraph.handleNodeClick"
			| "UiPanel.toolButtonClicked"
			| "UiPanel.toolButtonDropDownItemClicked"
			| "UiTable.cellEditingStarted"
			| "UiTable.cellEditingStopped"
			| "UiTable.rowSelected"
			| "UiTable.multipleRowsSelected"
			| "UiTable.sortingChanged"
			| "UiTable.tableDataRequest"
			| "UiTable.requestNestedData"
			| "UiTable.fieldOrderChange"
			| "UiTable.columnSizeChange"
			| "UiTable.headerFieldValueChanged"
			| "UiTable.headerFieldEvent"
			| "UiTable.footerFieldValueChanged"
			| "UiTable.footerFieldEvent"
			| "UiTabPanel.tabSelected"
			| "UiTabPanel.tabNeedsRefresh"
			| "UiTabPanel.tabClosed"
			| "UiTabPanel.toolButtonClicked"
			| "UiTabPanel.toolButtonDropDownItemClicked"
			| "UiTimeGraph.dataNeeded"
			| "UiTimeGraph.zoomed"
			| "UiTimeGraph.intervalSelected"
			| "AbstractUiToolContainer.toolbarButtonClick"
			| "AbstractUiToolContainer.toolbarDropDownItemClick"
			| "UiTree.nodeSelected"
			| "UiTree.requestTreeData"
			| "UiWorkSpaceLayout.layoutChanged"
			| "UiWorkSpaceLayout.viewDraggedToNewWindow"
			| "UiWorkSpaceLayout.viewNeedsRefresh"
			| "UiWorkSpaceLayout.childWindowCreationFailed"
			| "UiWorkSpaceLayout.childWindowClosed"
			| "UiWorkSpaceLayout.viewTabSelected"
			| "UiWorkSpaceLayout.viewTabClosed"
			| "UiWorkSpaceLayout.viewsMinimized"
			| "UiWorkSpaceLayout.viewsRestored"
			| "UiWorkSpaceLayout.viewsMaximized"
			| "UiSingleRecordFieldContainer.fieldValueChanged"
			| "UiSingleRecordFieldContainer.fieldEvent"
			| "UiMultiRecordFieldContainer.fieldValueChanged"
			| "UiMultiRecordFieldContainer.fieldEvent";
	componentId: string;
	[key: string]: any;
}